import React, { Component } from 'react'

export class SectionHeader extends Component {
    render() {
        const { title, className } = this.props;
        return (
            <h2 className={`${className} text-[40px] font-[700] text-[#2e2f46] max-[1101px]:text-[30px] max-[950px]:text-[24px] max-[600px]:text-[20px] max-[400px]:text-[18px]`}>
                {title}
            </h2>
        )
    }
}

export default SectionHeader